/* Así funciona · Estante para Baño sobre el Sanitario (274155), blanco, 3 niveles
   Todo es la foto real del mismo estante sobre el sanitario (pared de mármol en espiga y friso negro). Arranca con las
   toallas fuera del estante: una pila sobre la toalla del cesto, otra sobre la tapa del tanque y el cepillo redondo
   en el cesto (las toallas y el cepillo REALES de la foto, recortados). La clienta arrastra (o toca) cada cosa: la
   levanta por encima de la baranda real del nivel y la deja detrás, en su lugar real. Al final se funde la foto real.
   Lo de detrás de las toallas se rehízo con la misma pared y el mismo parante, sin IA (hacer.py).
   Ficha: 3 niveles, ganchos para toallas (y papel), color blanco. */
NHF.escena('estante-para-bano-sobre-el-sanitario', function (E) {
  const D = /*DATOS*/{"W":1680,"H":1758,"piezas":[{"id":"toallas-abajo","nombre":"Toallas","caja":[983,686,228,162],"src":"fn-estante-para-bano-sobre-el-sanitario-pieza-toallas-abajo.webp","abajo":[1093.4,842]},{"id":"toallas-medio","nombre":"Toallas","caja":[968,447,206,108],"src":"fn-estante-para-bano-sobre-el-sanitario-pieza-toallas-medio.webp","abajo":[1072.0,550]},{"id":"cepillo","nombre":"Cepillo","caja":[1056,401,46,55],"src":"fn-estante-para-bano-sobre-el-sanitario-pieza-cepillo.webp","abajo":[1078.6,451]}],"baranda_medio":{"src":"fn-estante-para-bano-sobre-el-sanitario-baranda-medio.webp","caja":[936,483,283,37],"arriba":486.6},"baranda_abajo":{"src":"fn-estante-para-bano-sobre-el-sanitario-baranda-abajo.webp","caja":[956,788,283,27],"arriba":790.9},"final":"fn-estante-para-bano-sobre-el-sanitario-final.webp","final_caja":[930,385,300,470],"base":"fn-estante-para-bano-sobre-el-sanitario-base.webp","base_caja":[160,40,1190,1130],"vista":[170,50,1170,1110]}/*FIN*/;
  // dónde arrancan: [centro x, apoyo y] en px de la foto
  const INICIO = { 'toallas-abajo': [365, 950], 'toallas-medio': [982, 1064], cepillo: [570, 993] };
  const Z = { 'toallas-abajo': 20, cepillo: 22, 'toallas-medio': 24 };
  const NOMBRE = { 'toallas-abajo': 'las toallas del cesto', 'toallas-medio': 'las toallas del tanque', cepillo: 'el cepillo' };
  const PASO = { 'toallas-abajo': 'Las toallas del cesto, al nivel de abajo', 'toallas-medio': 'Las del tanque, al nivel del medio', cepillo: 'El cepillo, encima de ellas' };
  const BARANDA = { 'toallas-abajo': D.baranda_abajo, 'toallas-medio': D.baranda_medio };
  const ORDEN = ['toallas-abajo', 'toallas-medio', 'cepillo'];
  const movil = window.innerWidth < 760;
  const S = E.lienzo({ w: D.W, h: D.H, vista: D.vista, vistaMovil: D.vista });
  E.titulo('El tanque libre, [las toallas a la mano].', 'Arrastra cada cosa a su nivel del estante (o tócala).');
  E.conSonido();
  S.cargando(true);
  S.img(D.base, D.base_caja, { z: 1, alt: 'Estante blanco de 3 niveles sobre el sanitario, con ganchos a los lados' });
  const final = S.img(D.final, D.final_caja, { z: 40, opacidad: 0 });
  final.style.transition = 'opacity .6s ease';
  // barandas reales: van por delante de lo que entra a cada nivel
  S.img(D.baranda_medio.src, D.baranda_medio.caja, { z: 30 });
  S.img(D.baranda_abajo.src, D.baranda_abajo.caja, { z: 30 });
  E.cargar([D.base, D.final, D.baranda_medio.src, D.baranda_abajo.src].concat(D.piezas.map(p => p.src))).then(() => S.cargando(false));

  const st = document.createElement('style');
  st.textContent = '[data-nhf-handle="estante-para-bano-sobre-el-sanitario"] .ebs-agarre{position:absolute;pointer-events:auto;cursor:grab;border-radius:24px;touch-action:none}' +
    '[data-nhf-handle="estante-para-bano-sobre-el-sanitario"] .is-arrastrando .ebs-agarre{cursor:grabbing}';
  E.raiz.appendChild(st);

  E.pasos(ORDEN.map(id => PASO[id]));
  E.paso(0);
  const lect = E.lectura({ etiqueta: 'En el estante' }); lect.poner('0', 'de 3');
  const bAuto = E.boton('Guárdalas por mí', () => autoGuardar(), { icono: 'toca' });
  E.nota('Tres niveles sobre el sanitario y ganchos a los lados para la toalla de mano y el papel.');

  let puestas = 0, ocupado = false;
  const k = movil ? 358 / D.vista[2] : 1;
  const piezas = D.piezas.map(p => {
    const [x, y, w, h] = p.caja;
    const ini = INICIO[p.id];
    const dx0 = ini[0] - p.abajo[0], dy0 = ini[1] - p.abajo[1];
    // sombra de apoyo (oscurece la superficie real donde descansa)
    const ancho = w * 0.94;
    const sombra = S.div([ini[0] - ancho / 2, ini[1] - 7, ancho, 13], { z: Z[p.id] - 1 });
    sombra.style.cssText += ';border-radius:50%;background:radial-gradient(closest-side,rgba(40,32,24,.45),rgba(40,32,24,.18) 55%,rgba(40,32,24,0));mix-blend-mode:multiply;transition:opacity .3s ease';
    const g = S.grupo(p.caja, { z: Z[p.id] });
    S.img(p.src, p.caja, { en: g, alt: p.nombre });
    g.style.filter = 'drop-shadow(0 4px 5px rgba(40,32,24,.2))';
    const mx = Math.max(4, (48 / k - w) / 2), my = Math.max(4, (48 / k - h) / 2);
    const ag = E.el('span', 'ebs-agarre');
    ag.style.cssText = 'left:' + (-mx) + 'px;top:' + (-my) + 'px;width:' + (w + 2 * mx) + 'px;height:' + (h + 2 * my) + 'px';
    g.appendChild(ag);
    const P = { p, g, ag, sombra, dx0, dy0, puesta: false };
    P.arr = E.arrastrable(g, {
      etiqueta: (p.id === 'cepillo' ? 'Cepillo' : 'Toallas') + ': llévalo a su nivel',
      destinos: [{ x: x + w / 2, y: y + h / 2, r: 200, id: p.id }],
      alEmpezar() {
        if (P.puesta || ocupado) return;
        sombra.style.opacity = 0;
        g.style.filter = 'drop-shadow(0 22px 18px rgba(40,32,24,.3))';
        g.style.zIndex = 60;
        E.sonido.tono(700, .04, .02);
      },
      alSoltar(dest, pos) {
        if (P.puesta) return;
        const movio = Math.hypot(pos.dx - P.dx0, pos.dy - P.dy0);
        if (dest || movio < 12) poner(P);
        else volver(P);
      },
      alTeclado() { poner(P); }
    });
    g.style.pointerEvents = 'none';
    P.arr.mover(dx0, dy0);
    return P;
  });
  const pieza = id => piezas.find(q => q.p.id === id);

  function viaje(P, x1, y1, ms, alto) {
    const a = P.arr.pos(), x0 = a.dx, y0 = a.dy;
    const h = alto == null ? Math.min(80, 25 + Math.abs(y1 - y0) * 0.1) : alto;
    return E.animarP(ms, kk => {
      P.arr.mover(x0 + (x1 - x0) * kk, y0 + (y1 - y0) * kk - Math.sin(Math.PI * kk) * h);
    });
  }
  async function poner(P) {
    if (P.puesta) return;
    if (ocupado) { volver(P); return; }
    // el cepillo va encima de las toallas del medio: primero ellas
    if (P.p.id === 'cepillo' && !pieza('toallas-medio').puesta) {
      S.pista('Primero las toallas del tanque', 'mano');
      volver(P); return;
    }
    P.puesta = true; ocupado = true;
    P.ag.style.pointerEvents = 'none';
    P.sombra.style.opacity = 0;
    P.g.style.zIndex = 60;
    P.g.style.filter = 'drop-shadow(0 16px 14px rgba(40,32,24,.24))';
    const bar = BARANDA[P.p.id];
    if (bar) {
      // se levanta por encima de la baranda real y se baja detrás de ella
      const alza = P.p.abajo[1] - bar.arriba + 8;
      await viaje(P, 0, -alza, 600);
      P.g.style.zIndex = 25;
      await E.animarP(420, kk => P.arr.mover(0, -alza * (1 - kk)), E.salida);
    } else {
      await viaje(P, 0, -4, 520);
      await E.animarP(150, kk => P.arr.mover(0, -4 + 4 * kk));
    }
    P.g.style.transition = 'filter .25s ease'; P.g.style.filter = 'none';
    E.sonido.tono(1900, .07, .03); setTimeout(() => E.sonido.tono(2500, .06, .02), 70); E.vibrar(10);
    puestas++;
    lect.poner(String(puestas), 'de 3');
    E.paso(puestas);
    ocupado = false;
    if (puestas >= 3) {
      bAuto.hidden = true; S.pista(null);
      await E.esperar(250);
      final.style.opacity = 1;   // queda la foto real exacta
      E.listo('Así queda: el tanque libre y cada cosa en su nivel, a la mano.', reiniciar);
    } else {
      const sig = ORDEN.map(pieza).find(q => !q.puesta);
      S.pista('Ahora ' + NOMBRE[sig.p.id], 'mano');
    }
  }
  function volver(P) {
    P.g.style.filter = 'drop-shadow(0 4px 5px rgba(40,32,24,.2))';
    viaje(P, P.dx0, P.dy0, 420).then(() => { P.sombra.style.opacity = 1; P.g.style.zIndex = Z[P.p.id]; });
  }
  async function autoGuardar() {
    bAuto.hidden = true;
    for (const id of ORDEN) {
      const P = pieza(id);
      while (ocupado) await E.esperar(100);   // si la clienta está moviendo una, se espera
      if (!P.puesta) { await poner(P); await E.esperar(200); }
    }
  }
  function reiniciar() {
    E.noListo(); puestas = 0; ocupado = false;
    final.style.opacity = 0;
    piezas.forEach(P => {
      P.puesta = false;
      P.g.style.transition = 'none'; P.g.style.zIndex = Z[P.p.id];
      P.g.style.filter = 'drop-shadow(0 4px 5px rgba(40,32,24,.2))';
      P.ag.style.pointerEvents = 'auto';
      P.arr.mover(P.dx0, P.dy0, 500);
      P.sombra.style.opacity = 1;
    });
    lect.poner('0', 'de 3'); bAuto.hidden = false; E.paso(0);
    S.pista('Arrastra cada cosa a su nivel', 'mano');
  }
  S.pista('Arrastra cada cosa a su nivel', 'mano');
});
